import { RefreshToken } from '@crossnokaye/typescript-sdk/models/components';
import { Label, withTooltip } from '@crossnokaye/ux-common';
import { DataTableColumnDef, DataTableHeadFn } from '@crossnokaye/ux-smarts';

import { EditTokenAction } from '@/features/tokens/components/actions/EditTokenAction';
import { RevokeTokenAction } from '@/features/tokens/components/actions/RevokeTokenAction';

const Typeography = withTooltip(Label);

const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const columns: DataTableColumnDef<RefreshToken, RefreshToken>[] = [
  {
    accessorKey: 'name',
    cell: ({ row }) => (
      <Typeography tooltipContent={row.original?.description}>
        <span className={'text-left px-3'}>{row.original?.name}</span>
      </Typeography>
    ),
    enableColumnFilter: false,
    enableSorting: true,
    header: DataTableHeadFn,
    headerText: 'Name',
    id: 'name',
  },
  {
    accessorKey: 'expiresAt',
    cell: ({ row }) => formatDate(row.original?.expiresAt?.toISOString() ?? ''),
    enableColumnFilter: false,
    enableSorting: true,
    header: DataTableHeadFn,
    headerText: 'Expires',
    id: 'expiresAt',
  },
  {
    accessorKey: 'actions',
    cell: ({ row }) => (
      <div className={'flex items-center px-3'}>
        <EditTokenAction token={row.original} />
        <RevokeTokenAction
          token={row.original}
          className={'text-destructive hover:text-destructive'}
        />
      </div>
    ),
    enableColumnFilter: false,
    enableSorting: false,
    header: DataTableHeadFn,
    headerText: '',
    id: 'actions',
  },
];
